export default {"src":"/_next/static/media/news-l1.275347bc.svg","height":60,"width":285,"blurWidth":0,"blurHeight":0};